import TravelSafetyHero from './components/TravelSafetyHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { travelSafetyBottomFeatures } from "./data/travelSafetyBottomFeatures";
import { travelSafetyTestimonials } from "./data/travelSafetyTestimonials";
import { travelSafetyFeaturesList } from "./data/travelSafetyFeaturesList";

const TravelSafety = () => {
    return (
        <>
            <Helmet>
                <title>Best Location Tracking App for Travelers - Device Tracker Plus</title>
                <meta name="description" content="Travel with confidence. Share your live location, send emergency alerts, and check in from anywhere with our smart safety app for solo travellers." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/travel-safety" />
            </Helmet>
            <TravelSafetyHero />
            <Features sectionTitle="Essential Features for Travelers" features={travelSafetyFeaturesList} />
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={travelSafetyTestimonials} />
            <WhyDtp reasons={travelSafetyBottomFeatures} title="Why Travelers Trust Device Tracker Plus"/>

        </>
    );
}

export default TravelSafety;